export const BP_ORDER_GET_LIST = "/businessorder/list";
export const BP_ORDER_SEARCH_PROPOSAL ="/businessorder/searchProposals";
export const BP_ORDER_DOWNLOAD = "/businessorder/download";